// 个人中心
import User from '@/views/user/index.vue'

export default [
  {
    path: '/user',
    name: 'user',
    component: User,
  },
]
